const translations = {
  "en": {
    "Crypto": "Crypto",
    "HK Stock": "HK Stock",
    "Stocks": "Stocks",
    "US Stock": "US Stock"
  },
  "zh-tw": {
    "Crypto": "加密貨幣",
    "HK Stock": "香港股票",
    "Stocks": "股票",
    "US Stock": "美股"
  }
};

export default translations;
